export default {
  'clocks': [],
  'permanentRequiredFields': [
    'Salutation',
    'RequestInterest',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'cooperation': [
      'PostalCode',
      'Company',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'other': [
      'PostalCode'
    ]
  }
}
